module.exports = __webpack_public_path__ + "img/singletrack-study-company.c2b894b9.png";